module.exports = __webpack_public_path__ + "static/media/retouchIMG_2652-min.67dfe63a.png";